<div class="sites-map">
    <app-ol-main #map_db *ngIf="mapcontrol" [showCardTitle]="false" [showButtonLayers]="true"></app-ol-main>
</div>